import React from 'react';
import PropTypes from 'prop-types';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {ALERT__24} from '@homeaway/svg-defs/lib/defs/ALERT__24';
import {SVGIcon} from '@homeaway/react-svg';
import {Link} from '@homeaway/react-localization-components';

const LoadingErrorDisplay = ({ctaLabel, ctaLink, message, title}) => {
    return (
        <div className="text-center">
            <span className="text-brand">
                <SVGIcon markup={ALERT__24} useFill />
            </span>
            {title && (
                <p>
                    <strong>{title}</strong>
                </p>
            )}
            <p>{message}</p>
            <Link href={ctaLink}>
                {(localizedUrl) => (
                    <ButtonPrimary
                        className={'btn--nowrap'}
                        href={localizedUrl}
                        label={ctaLabel}
                    />
                )}
            </Link>
        </div>
    );
};

LoadingErrorDisplay.propTypes = {
    ctaLabel: PropTypes.string,
    ctaLink: PropTypes.string,
    message: PropTypes.string,
    title: PropTypes.string,
};

export default LoadingErrorDisplay;
